<template>
    <div>
        <div style="padding-left: 20px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/manage' }">网站配置</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/">文字维护</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='less'>

</style>
